export default __webpack_public_path__ + "static/media/Efficient Ordering.c4efffe5.png";